import React, { useRef, useState } from "react";
import { Box, Button, Grid, Modal, Typography,CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import "../../components/style.scss";
import "./UploadPopup.scss";
import Upload from "../../components/Upload";
import uploadCloudBlueImg from "../../assets/icons/upload-cloud-blue.png";
import deleteIcon from "../../assets/icons/delete-red.svg";
import cameraImg from "../../assets/icons/camera.png";
import fileTextImg from "../../assets/icons/file-text.png";
import CropImage from "./CropImage";
import WebCamera from "./WebCamera";
import { checkFileSize } from "../../utilis/common-funtions";
import { ALLOWED_FILE_FORMATS, MAX_FILE_SIZE_MB, PDF_FILE_SIZE_MB } from "../../config/constant";
import SnackbarAlert from "../snackbar-alert/SnackbarAlert";
import CropIcon from "@mui/icons-material/Crop";
import {
  deleteImage,
} from "../../pages/customer-form/customer-form.slice";
import { compressAndUploadFile } from "../../pages/customer-form/compressionUpload";
import { isNotImageFile } from "../../utilis/uploadUtils";
const { REACT_APP_S3_BASE_URL } = process.env;

function UploadPopupTwoImages({
  heading,
  totalImages,
  closePopup,
  handleImageValue,
  uploadedImageFront,
  uploadedImageBack,
  fieldName,
  handleUpdateImageData,
  handlePhysicalImage,
  selectedOptionValue,
  hidePhysicalCopyOption = false, 
  dynamicSize='',    
  showDeleteIcon = true,
  showPreview = "",
  documentName,
  documentNumber,
}) {
  const dispatch = useDispatch();
  const { oppId, voucherId } = useParams();
  const opportunityId = oppId || voucherId;
  const [openModal, setOpenModal] = useState(true);
  const [selectedOption, setSelectedOption] = useState(
    selectedOptionValue === true ? "physical" : "files"
  );
  const [selectedFilesFront, setSelectedFilesFront] = useState([]);
  const [selectedFilesBack, setSelectedFilesBack] = useState([]);
  const [showCropImageFront, setShowCropImageFront] = useState(false);
  const [showCropImageBack, setShowCropImageBack] = useState(false);
  const [showWebCameraImageFront, setShowWebCameraImageFront] = useState(true);
  const [showWebCameraImageBack, setShowWebCameraImageBack] = useState(true);
  const croppedFrontImageRef = useRef();
  const croppedBackImageRef = useRef();
  const [rotateFront, setFrontRotate] = useState(0); // state in parent
  const [rotateBack, setBackRotate] = useState(0); // state in parent
  const [loading,setLoading] = useState(false)

  const [uploadedFilesFront, setUploadedFilesFront] = useState(
    uploadedImageFront
  );
  const [uploadedFilesBack, setUploadedFilesBack] = useState(uploadedImageBack);
  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleFileChangeFront = (e) => {
    const files = Array.from(e.target.files);
    validationFront(files, e);
    e.target.value = null;
  };

  const handleFileChangeBack = (e) => {
    const files = Array.from(e.target.files);
    validationBack(files, e);
    e.target.value = null;
  };

  const handleFileChangeWebCameraFront = (file) => {
    const files = Array.from([file]);
    setShowWebCameraImageFront(false);
    validationFront(files);
  };

  const handleFileChangeWebCameraBack = (file) => {
    const files = Array.from([file]);
    setShowWebCameraImageBack(false);
    validationBack(files);
  };

  const handleCropImageFront = () => {
    setShowCropImageFront(true);
  };

  const handleCropImageBack = () => {
    setShowCropImageBack(true);
  };

  const validationFront = (files, event) => {
    files.forEach((file) => {
      const isNonImage = isNotImageFile(file);
      let maxSize = isNonImage ? PDF_FILE_SIZE_MB : MAX_FILE_SIZE_MB;
      let errorMessage = isNonImage
        ? `PDF file size must be less than ${maxSize}MB: ${file.name}`
        : `Image file size must be less than ${maxSize}MB: ${file.name}`;

      if (dynamicSize) {
        maxSize = dynamicSize;
        errorMessage = `File size must be less than ${maxSize}MB: ${file.name}`;
      } else if (isNonImage) {
        maxSize = PDF_FILE_SIZE_MB;
        errorMessage = `PDF file size must be less than ${maxSize}MB: ${file.name}`;
      } else {
        maxSize = MAX_FILE_SIZE_MB;
        errorMessage = `Image file size must be less than ${maxSize}MB: ${file.name}`;
      }

      if (!checkFileSize(file, maxSize)) {
        setSnackBarconfig({
          open: true,
          message: errorMessage,
          severity: "error",
        });
      } else if (!ALLOWED_FILE_FORMATS?.includes(file.type)) {
        setSnackBarconfig({
          open: true,
          message: "Unsupported file format: " + file.name,
          severity: "error",
        });
      } else {
        setSelectedFilesFront((prevFiles) => [file]);

        // Automatically open crop interface for image files
        if (!isNonImage) {
          setShowCropImageFront(true);
        }
      }
    });
  };

  const validationBack = (files, event) => {
    files.forEach((file) => {
      const isNonImage = isNotImageFile(file);
      let maxSize = isNonImage ? PDF_FILE_SIZE_MB : MAX_FILE_SIZE_MB;
      let errorMessage = isNonImage
        ? `PDF file size must be less than ${maxSize}MB: ${file.name}`
        : `Image file size must be less than ${maxSize}MB: ${file.name}`;

      if (dynamicSize) {
        maxSize = dynamicSize;
        errorMessage = `File size must be less than ${maxSize}MB: ${file.name}`;
      } else if (isNonImage) {
        maxSize = PDF_FILE_SIZE_MB;
        errorMessage = `PDF file size must be less than ${maxSize}MB: ${file.name}`;
      } else {
        maxSize = MAX_FILE_SIZE_MB;
        errorMessage = `Image file size must be less than ${maxSize}MB: ${file.name}`;
      }

      if (!checkFileSize(file, maxSize)) {
        setSnackBarconfig({
          open: true,
          message: errorMessage,
          severity: "error",
        });
      } else if (!ALLOWED_FILE_FORMATS.includes(file.type)) {
        setSnackBarconfig({
          open: true,
          message: "Unsupported file format: " + file.name,
          severity: "error",
        });
      } else {
        setSelectedFilesBack((prevFiles) => [file]);

        // Automatically open crop interface for image files
        if (!isNonImage) {
          setShowCropImageBack(true);
        }
      }
    });
  };

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };
  const handleCroppedImageReady = (file, type) => {
    if (type === 'front') {
      croppedFrontImageRef.current = file;
    } else if (type === 'back') {
      croppedBackImageRef.current = file;
    }
  };
  const handleUploadImages = async () => {
    const frontFile = croppedFrontImageRef.current || selectedFilesFront[0];
    const backFile = croppedBackImageRef.current || selectedFilesBack[0];

    if (!selectedFilesFront?.length) {
      setSnackBarconfig({
        open: true,
        message: "Front image is mandatory. Please upload a front image. ",
        severity: "error",
      });
      return;
    }

    let imageValues = ["", ""];
    setLoading(true)

    try {
      // Upload front image
      if (selectedFilesFront?.length) {
        const presignedUrlPayloadFront = {
          folder: `images/${opportunityId}`,
          key: frontFile?.name.replace(/\s+/g, ""),
        };

        const resultFront = await dispatch(compressAndUploadFile({
          file: frontFile,
          presignedUrlPayload: presignedUrlPayloadFront,
          fieldName: fieldName, // Pass fieldName for dynamic dimensions
        })).unwrap();

        if (resultFront?.uploadResult?.status === 200) {
          const frontImageKey = resultFront?.presignedResponse?.data?.key;
          imageValues[0] = frontImageKey !== uploadedFilesFront ? frontImageKey : uploadedFilesFront;
        }
      }

      // Upload back image
      if (selectedFilesBack?.length) {
        const presignedUrlPayloadBack = {
          folder: `images/${opportunityId}`,
          key: backFile?.name.replace(/\s+/g, ""),
        };

        const resultBack = await dispatch(compressAndUploadFile({
          file: backFile,
          presignedUrlPayload: presignedUrlPayloadBack,
          fieldName: fieldName, // Pass fieldName for dynamic dimensions
        })).unwrap();

        if (resultBack?.uploadResult?.status === 200) {
          const backImageKey = resultBack?.presignedResponse?.data?.key;
          imageValues[1] = backImageKey !== uploadedFilesBack ? backImageKey : uploadedFilesBack;
        }
      }

      handleImageValue(fieldName, imageValues);
      setLoading(false)
      closePopup(false);
    } catch (error) {
      console.error('Upload failed:', error);
      setSnackBarconfig({
        open: true,
        message: error || 'Upload failed. Please try again.',
        severity: "error",
      });
      setLoading(false)

    }
  };

  const handleUploadImagesFront = async () => {
    let imageValues = ["", uploadedFilesBack];
    const frontFile = croppedFrontImageRef.current || selectedFilesFront[0];
    setLoading(true)
    try {
      const presignedUrlPayloadFront = {
        folder: `images/${opportunityId}`,
        key: frontFile?.name.replace(/\s+/g, ""),
      };

      const resultFront = await dispatch(compressAndUploadFile({
        file: frontFile,
        presignedUrlPayload: presignedUrlPayloadFront,
        fieldName: fieldName, // Pass fieldName for dynamic dimensions
      })).unwrap();

      if (resultFront?.uploadResult?.status === 200) {
        const frontImageKey = resultFront?.presignedResponse?.data?.key;
        imageValues[0] = frontImageKey !== uploadedFilesFront ? frontImageKey : uploadedFilesFront;
        handleImageValue(fieldName, imageValues);
        closePopup(false);
      }
      setLoading(false)

    } catch (error) {
      console.error('Front image upload failed:', error);
      setSnackBarconfig({
        open: true,
        message: error || 'Front image upload failed. Please try again.',
        severity: "error",
      });
    }
  };

  const handleUploadImagesBack = async () => {
    let imageValues = [uploadedFilesFront, ""];
    const backFile = croppedBackImageRef.current || selectedFilesBack[0];
    setLoading(true)
    try {
      const backFile = selectedFilesBack[0];
      const presignedUrlPayloadBack = {
        folder: `images/${opportunityId}`,
        key: backFile?.name.replace(/\s+/g, ""),
      };

      const resultBack = await dispatch(compressAndUploadFile({
        file: backFile,
        presignedUrlPayload: presignedUrlPayloadBack,
        fieldName: fieldName, // Pass fieldName for dynamic dimensions
      })).unwrap();

      if (resultBack?.uploadResult?.status === 200) {
        const backImageKey = resultBack?.presignedResponse?.data?.key;
        imageValues[1] = backImageKey !== uploadedFilesBack ? backImageKey : uploadedFilesBack;
        handleImageValue(fieldName, imageValues);
        closePopup(false);
      }
      setLoading(false)

    } catch (error) {
      setLoading(false)

      console.error('Back image upload failed:', error);
      setSnackBarconfig({
        open: true,
        message: error || 'Back image upload failed. Please try again.',
        severity: "error",
      });
    }
  };

  const handleUploadPhysical = (value) => {
    if(!hidePhysicalCopyOption){
      handlePhysicalImage(fieldName, value);
    }
    closePopup(false);
  };

  const handleDeleteImageFront = () => {
    if (selectedFilesFront.length > 0) {
      setSelectedFilesFront([]);
      setShowCropImageFront(false);
      setShowWebCameraImageFront(true);
    } else {
      let payload = {
        key: uploadedFilesFront[0],
      };
      dispatch(deleteImage(payload))
        .unwrap()
        .then((res) => {
          if (res?.success) {
            setUploadedFilesFront([]);
            handleUpdateImageData(
              fieldName,
              uploadedFilesBack !== "" ? ["", uploadedFilesBack] : []
            );
          }
        });
    }
  };

  const handleDeleteImageBack = () => {
    if (selectedFilesBack.length > 0) {
      setSelectedFilesBack([]);
      setShowCropImageBack(false);
      setShowWebCameraImageBack(true);
    } else {
      let payload = {
        key: uploadedFilesBack[0],
      };
      dispatch(deleteImage(payload))
        .unwrap()
        .then((res) => {
          if (res?.success) {
            setUploadedFilesBack([]);
            handleUpdateImageData(
              fieldName,
              uploadedFilesFront !== "" ? [uploadedFilesFront, ""] : []
            );
          }
        });
    }
  };

  // Drag and Drop Handlers for Front Image
  const handleDragOverFront = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDropFront = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = Array.from(e.dataTransfer.files);
    validationFront(files, e);
  };

  // Drag and Drop Handlers for Back Image
  const handleDragOverBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDropBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = Array.from(e.dataTransfer.files);
    validationBack(files, e);
  };

  const showBackSideDiv = () => {
    if (showPreview === "show" && uploadedFilesBack?.length > 0) {
      return true
    } else if (showPreview === "show" && uploadedFilesBack?.length === 0) {
      return false
    } 
    return true
  }

  return (
    <div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(!openModal);
        }}
        hideBackdrop={true}
        disableEscapeKeyDown={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="UploadDetailsModal"
      >
        <Box
          className="modalContainer"
          sx={{
            width: { xs: "90%", sm: "80%", md: "70%", lg: "50%" },
            maxHeight: "80vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 1,
            p: 4,
          }}
        >
          <Box sx={{ border: "0" }}>
            <div className="closeModal" onClick={() => closePopup(false)}>
              <HighlightOffIcon />
            </div>
            <Typography
              className="modalTitle"
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              {(uploadedFilesFront?.length > 0 && uploadedFilesBack?.length > 0) || (showPreview === "show")
                ? "Preview"
                : heading}
            </Typography>
            {documentName && (
              <Typography
                component="span"
                sx={{ fontSize: "14px", fontWeight: "400" }}
              >
                {documentName}: &nbsp;
              </Typography>
            )}
            {documentNumber && (
              <Typography
              component="span"
              sx={{ fontSize: "14px", fontWeight: "600" }}
              >
                {documentNumber}
              </Typography>
            )}
            {(uploadedFilesFront?.length === 0 ||
              uploadedFilesBack?.length === 0) && (showPreview === "notShow") ? (
              <Typography
                className="titlePra"
                sx={{ fontWeight: "bold", textAlign: "center" }}
              >
                Please select how you'd like to submit your document.
              </Typography>
            ) : null}
            {(uploadedFilesFront?.length === 0 ||
              uploadedFilesBack?.length === 0) && !showPreview ? (
              <div className="uploadTags">
                <Grid container spacing={3}>
                  <Grid
                    item
                    xs={12}
                    sm={hidePhysicalCopyOption ? 6 : 4}
                    md={hidePhysicalCopyOption ? 6 : 4}
                    lg={hidePhysicalCopyOption ? 6 : 4}
                    xl={hidePhysicalCopyOption ? 6 : 4}
                    className="boxCheckInputContainer"
                  >
                    <div
                      className={`checkBox ${selectedOption === "files" && `selectedCheckBox`
                        }`}
                      onClick={() => {
                        setSelectedOption("files");
                        if(!hidePhysicalCopyOption){
                          handlePhysicalImage(fieldName, false);
                        }
                        setSelectedFilesFront([]);
                        setSelectedFilesBack([]);
                      }}
                    >
                      <div>
                        <span className="flexIcon">
                          <img
                            src={uploadCloudBlueImg}
                            alt=""
                            style={{ height: "20px", width: "20px" }}
                          />
                          Upload from files
                        </span>
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={hidePhysicalCopyOption ? 6 : 4}
                    md={hidePhysicalCopyOption ? 6 : 4}
                    lg={hidePhysicalCopyOption ? 6 : 4}
                    xl={hidePhysicalCopyOption ? 6 : 4}
                    className="boxCheckInputContainer"
                  >
                    <div
                      className={`checkBox ${selectedOption === "camera" && `selectedCheckBox`
                        }`}
                      onClick={() => {
                        setSelectedOption("camera");
                        if(!hidePhysicalCopyOption){
                          handlePhysicalImage(fieldName, false);
                        }
                        setSelectedFilesFront([]);
                        setSelectedFilesBack([]);
                      }}
                    >
                      <div>
                        <span className="flexIcon">
                          <img
                            src={cameraImg}
                            alt=""
                            style={{ height: "20px", width: "20px" }}
                          />
                          Capture from camera
                        </span>
                      </div>
                    </div>
                  </Grid>
                  {!hidePhysicalCopyOption && <Grid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    className="boxCheckInputContainer"
                  >
                    <div
                      className={`checkBox ${selectedOption === "physical" && `selectedCheckBox`
                        }`}
                      onClick={() => {
                        setSelectedOption("physical");
                        setSelectedFilesFront([]);
                        setSelectedFilesBack([]);
                        handleUpdateImageData(fieldName, []);
                      }}
                    >
                      <div>
                        <span className="flexIcon">
                          <img
                            src={fileTextImg}
                            alt=""
                            style={{ height: "20px", width: "20px" }}
                          />
                          Upload Later
                        </span>
                      </div>
                    </div>
                  </Grid>}
                </Grid>
              </div>
            ) : null}
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
                width: "100%",
                gap: 2,
                mb: 2,
              }}
            >
              {(selectedFilesFront.length > 0 ||
                selectedFilesBack.length > 0) &&
                uploadedFilesFront.length < 1 &&
                uploadedFilesBack.length < 1 ? (
                <Button
                  sx={{
                    width: "100px",
                    height: "48px",
                    borderRadius: "8px",
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#092552",
                    },
                  }}
                  onClick={handleUploadImages}
                >
                    {loading ? (
                      <CircularProgress size={24} sx={{ color: "white" }} />
                    ) : (
                      "Save"
                    )}
                </Button>
              ) : null}
              {selectedFilesFront.length > 0 && uploadedFilesBack.length > 0 ? (
                <Button
                  sx={{
                    width: "100px",
                    height: "48px",
                    borderRadius: "8px",
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#092552",
                    },
                  }}
                  onClick={handleUploadImagesFront}
                >
                  {loading ? (
                      <CircularProgress size={24} sx={{ color: "white" }} />
                    ) : (
                      "Save"
                    )}
                </Button>
              ) : null}
              {selectedFilesBack.length > 0 && uploadedFilesFront.length > 0 ? (
                <Button
                  sx={{
                    width: "100px",
                    height: "48px",
                    borderRadius: "8px",
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#092552",
                    },
                  }}
                  onClick={handleUploadImagesBack}
                >
                  {loading ? (
                      <CircularProgress size={24} sx={{ color: "white" }} />
                    ) : (
                      "Save"
                    )}
                </Button>
              ) : null}
              {selectedOption === "physical" && (
                <Button
                  sx={{
                    width: "100px",
                    height: "48px",
                    borderRadius: "8px",
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#092552",
                    },
                  }}
                  onClick={() => handleUploadPhysical(true)}
                >
                  Save
                </Button>
              )}
            </Box>
            {selectedOption === "files" && (
              <>
                {totalImages === 2 && (
                  <>
                    <div
                      className="frontSide"
                      onDragOver={handleDragOverFront}
                      onDrop={handleDropFront}
                      style={{
                        border: "1px dashed #ddd",
                        padding: "20px",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            lineHeight: "22px",
                            fontWeight: "400",
                            color: "#1A407D",
                            mb: 1,
                          }}
                        >
                          Front
                        </Typography>
                        {uploadedFilesFront?.length > 0 && showDeleteIcon && (
                          <Button
                            sx={{
                              width: "44px",
                              height: "44px",
                              borderRadius: "8px",
                              background: "#fff",
                              textTransform: "capitalize",
                              border: "1px solid #FDA29B",
                              "&:hover": {
                                backgroundColor: "#FDA29B",
                              },
                            }}
                            onClick={handleDeleteImageFront}
                          >
                            <img src={deleteIcon} alt="" />
                          </Button>
                        )}

                        {selectedFilesFront?.length > 0 && (
                          <>
                            <div style={{ textAlign: "right", display: 'flex', gap: '12px', width: '50%', justifyContent: 'end' }}>
                              {showCropImageFront === false && (
                                <Button
                                  sx={{
                                    width: "72.5px",
                                    height: "44px",
                                    borderRadius: "8px",
                                    textTransform: "capitalize",
                                    backgroundColor: "#fff",
                                    color: "#092552",
                                    border: "1px solid #092552",
                                    "&:hover": {
                                      backgroundColor: "#092552",
                                      color: "#fff",
                                    },
                                  }}
                                  onClick={handleCropImageFront}
                                >
                                  <CropIcon />

                                </Button>
                              )}
                              <Button
                                sx={{
                                  width: "72.5px",
                                  height: "44px",
                                  borderRadius: "8px",
                                  background: "#fff",
                                  textTransform: "capitalize",
                                  border: "1px solid #FDA29B",
                                  marginBottom: '15px',
                                  "&:hover": {
                                    backgroundColor: "#FDA29B",
                                  },
                                }}
                                onClick={handleDeleteImageFront}
                              >
                                <img src={deleteIcon} alt="" />
                              </Button>

                            </div>
                          </>
                        )}
                      </Box>

                      {selectedFilesFront?.length === 0 &&
                        uploadedFilesFront?.length === 0 && (
                          <Upload
                            handleFileChange={handleFileChangeFront}
                            path="front"
                            dynamicSize={dynamicSize}
                          />
                        )}
                      {showCropImageFront && (
                        <>
                          <CropImage
                            selectedFiles={selectedFilesFront}
                            handleFileChangeWebCamera={
                              handleFileChangeWebCameraFront
                            }
                            onCroppedImageReady={(file) => handleCroppedImageReady(file, 'front')}
                            rotate={rotateFront}
                          />
                          <div
                            style={{ textAlign: "center", marginBottom: "16px" }}
                          >
                            <label>Rotate: {rotateFront}°</label>
                            <input
                              type="range"
                              min="-180"
                              max="180"
                              step="1"
                              value={rotateFront}
                              onChange={(e) => setFrontRotate(Number(e.target.value))}
                              style={{ width: "100%" }}
                            />
                          </div>
                        </>
                      )}

                      {(selectedFilesFront?.length > 0 ||
                        uploadedFilesFront?.length > 0) &&
                        showCropImageFront === false ? (
                        <div className="uploadImage">
                          <img
                            src={
                              uploadedFilesFront?.length > 0
                                ? `${REACT_APP_S3_BASE_URL}/${uploadedFilesFront}`
                                : URL.createObjectURL(selectedFilesFront[0])
                            }
                            alt="front-image"
                          />
                        </div>
                      ) : null}
                    </div>

                    {showBackSideDiv() && <div
                      className="backSide"
                      onDragOver={handleDragOverBack}
                      onDrop={handleDropBack}
                      style={{
                        border: "1px dashed #ddd",
                        padding: "20px",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            lineHeight: "22px",
                            fontWeight: "400",
                            color: "#1A407D",
                            mb: 1,
                          }}
                        >
                          Back
                        </Typography>
                        {uploadedFilesBack?.length > 0 && showDeleteIcon && (
                          <Button
                            sx={{
                              width: "44px",
                              height: "44px",
                              borderRadius: "8px",
                              background: "#fff",
                              textTransform: "capitalize",
                              border: "1px solid #FDA29B",
                              "&:hover": {
                                backgroundColor: "#FDA29B",
                              },
                            }}
                            onClick={handleDeleteImageBack}
                          >
                            <img src={deleteIcon} alt="" />
                          </Button>
                        )}

                        {selectedFilesBack?.length > 0 && (
                          <>
                            <div style={{ textAlign: "right", display: 'flex', gap: '12px', width: '50%', justifyContent: 'end' }}>
                              {showCropImageBack === false && (
                                <Button
                                  sx={{
                                    width: "72.5px",
                                    height: "44px",
                                    borderRadius: "8px",
                                    textTransform: "capitalize",
                                    backgroundColor: "#fff",
                                    color: "#092552",
                                    border: "1px solid #092552",
                                    "&:hover": {
                                      backgroundColor: "#092552",
                                      color: "#fff",
                                    },
                                  }}
                                  onClick={handleCropImageBack}
                                >
                                  <CropIcon />

                                </Button>
                              )}
                              <Button
                                sx={{
                                  width: "72.5px",
                                  height: "44px",
                                  borderRadius: "8px",
                                  background: "#fff",
                                  textTransform: "capitalize",
                                  border: "1px solid #FDA29B",
                                  marginBottom: '15px',
                                  "&:hover": {
                                    backgroundColor: "#FDA29B",
                                  },
                                }}
                                onClick={handleDeleteImageBack}
                              >
                                <img src={deleteIcon} alt="" />
                              </Button>

                            </div>
                          </>
                        )}
                      </Box>

                    {(((selectedFilesBack?.length === 0) &&
                      (uploadedFilesBack?.length === 0)) || (showPreview === "notShow")) && (
                      <Upload
                        handleFileChange={handleFileChangeBack}
                        path="back"
                        dynamicSize={dynamicSize}
                      />
                    )}
                      {showCropImageBack && (
                        <>
                          <CropImage
                            selectedFiles={selectedFilesBack}
                            handleFileChangeWebCamera={
                              handleFileChangeWebCameraBack
                            }
                            onCroppedImageReady={(file) => handleCroppedImageReady(file, 'back')}
                            rotate={rotateBack}
                          />
                          <div
                            style={{ textAlign: "center", marginBottom: "16px" }}
                          >
                            <label>Rotate: {rotateBack}°</label>
                            <input
                              type="range"
                              min="-180"
                              max="180"
                              step="1"
                              value={rotateBack}
                              onChange={(e) => setBackRotate(Number(e.target.value))}
                              style={{ width: "100%" }}
                            />
                          </div>
                        </>
                      )}

                      {(selectedFilesBack?.length > 0 ||
                        uploadedFilesBack?.length > 0) &&
                        showCropImageBack === false ? (
                        <div className="uploadImage">
                          <img
                            src={
                              uploadedFilesBack?.length > 0
                                ? `${REACT_APP_S3_BASE_URL}/${uploadedFilesBack}`
                                : URL.createObjectURL(selectedFilesBack[0])
                            }
                            alt="front-image"
                          />
                        </div>
                      ) : null}
                    </div>}
                  </>
                )}
              </>
            )}

            {selectedOption === "camera" && (
              <>
                <div className="frontSide">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        lineHeight: "22px",
                        fontWeight: "400",
                        color: "#1A407D",
                        mb: 1,
                      }}
                    >
                      Front
                    </Typography>
                    {uploadedFilesFront?.length > 0 && (
                      <Button
                        sx={{
                          width: "44px",
                          height: "44px",
                          borderRadius: "8px",
                          background: "#fff",
                          textTransform: "capitalize",
                          border: "1px solid #FDA29B",
                          "&:hover": {
                            backgroundColor: "#FDA29B",
                          },
                        }}
                        onClick={handleDeleteImageFront}
                      >
                        <img src={deleteIcon} alt="" />
                      </Button>
                    )}

                    {selectedFilesFront?.length > 0 && (
                      <>
                        <div style={{ textAlign: "right", display: 'flex', gap: '12px', width: '50%', justifyContent: 'end' }}>
                          {showCropImageFront === false && (
                            <Button
                              sx={{
                                width: "72.5px",
                                height: "44px",
                                borderRadius: "8px",
                                textTransform: "capitalize",
                                backgroundColor: "#fff",
                                color: "#092552",
                                border: "1px solid #092552",
                                "&:hover": {
                                  backgroundColor: "#092552",
                                  color: "#fff",
                                },
                              }}
                              onClick={handleCropImageFront}
                            >
                              <CropIcon />

                            </Button>
                          )}
                          <Button
                            sx={{
                              width: "44px",
                              height: "44px",
                              borderRadius: "8px",
                              background: "#fff",
                              textTransform: "capitalize",
                              border: "1px solid #FDA29B",
                              marginBottom: '15px',
                              "&:hover": {
                                backgroundColor: "#FDA29B",
                              },
                            }}
                            onClick={handleDeleteImageFront}
                          >
                            <img src={deleteIcon} alt="" />
                          </Button>

                        </div>
                      </>
                    )}
                  </Box>

                  {selectedFilesFront?.length === 0 &&
                    uploadedFilesFront?.length === 0 && (
                      <WebCamera
                        handleFileChangeWebCamera={
                          handleFileChangeWebCameraFront
                        }
                      />
                    )}
                  {showCropImageFront && (
                    <>
                      <CropImage
                        selectedFiles={selectedFilesFront}
                        handleFileChangeWebCamera={handleFileChangeWebCameraFront}
                        onCroppedImageReady={(file) => handleCroppedImageReady(file, 'front')}
                        rotate={rotateFront}
                      />
                      <div
                        style={{ textAlign: "center", marginBottom: "16px" }}
                      >
                        <label>Rotate: {rotateFront}°</label>
                        <input
                          type="range"
                          min="-180"
                          max="180"
                          step="1"
                          value={rotateFront}
                          onChange={(e) => setFrontRotate(Number(e.target.value))}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </>
                  )}
                  {(selectedFilesFront?.length > 0 ||
                    uploadedFilesFront?.length > 0) &&
                    showCropImageFront === false ? (
                    <div className="uploadImage">
                      <img
                        src={
                          uploadedFilesFront?.length > 0
                            ? `${REACT_APP_S3_BASE_URL}/${uploadedFilesFront}`
                            : URL.createObjectURL(selectedFilesFront[0])
                        }
                        alt="front-image"
                      />
                    </div>
                  ) : null}
                </div>
                <div className="backSide">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        lineHeight: "22px",
                        fontWeight: "400",
                        color: "#1A407D",
                        mb: 1,
                      }}
                    >
                      Back
                    </Typography>
                    {uploadedFilesBack?.length > 0 && (
                      <Button
                        sx={{
                          width: "44px",
                          height: "44px",
                          borderRadius: "8px",
                          background: "#fff",
                          textTransform: "capitalize",
                          border: "1px solid #FDA29B",
                          "&:hover": {
                            backgroundColor: "#FDA29B",
                          },
                        }}
                        onClick={handleDeleteImageBack}
                      >
                        <img src={deleteIcon} alt="" />
                      </Button>
                    )}

                    {selectedFilesBack?.length > 0 && (
                      <>
                        <div style={{ textAlign: "right", display: 'flex', gap: '12px', width: '50%', justifyContent: 'end' }}>
                          {showCropImageBack === false && (
                            <Button
                              sx={{
                                width: "72.5px",
                                height: "44px",
                                borderRadius: "8px",
                                textTransform: "capitalize",
                                backgroundColor: "#fff",
                                color: "#092552",
                                border: "1px solid #092552",
                                "&:hover": {
                                  backgroundColor: "#092552",
                                  color: "#fff",
                                },
                              }}
                              onClick={handleCropImageBack}
                            >
                              <CropIcon />

                            </Button>
                          )}
                          <Button
                            sx={{
                              width: "44px",
                              height: "44px",
                              borderRadius: "8px",
                              background: "#fff",
                              textTransform: "capitalize",
                              border: "1px solid #FDA29B",
                              marginBottom: '15px',
                              "&:hover": {
                                backgroundColor: "#FDA29B",
                              },
                            }}
                            onClick={handleDeleteImageBack}
                          >
                            <img src={deleteIcon} alt="" />
                          </Button>

                        </div>
                      </>
                    )}
                  </Box>

                  {selectedFilesBack?.length === 0 &&
                    uploadedFilesBack?.length === 0 && (
                      <WebCamera
                        handleFileChangeWebCamera={
                          handleFileChangeWebCameraBack
                        }
                      />
                    )}
                  {showCropImageBack && (

                    <>
                      <CropImage
                        selectedFiles={selectedFilesBack}
                        handleFileChangeWebCamera={handleFileChangeWebCameraBack}
                        onCroppedImageReady={(file) => handleCroppedImageReady(file, 'back')}
                        rotate={rotateBack}
                      />
                      <div
                        style={{ textAlign: "center", marginBottom: "16px" }}
                      >
                        <label>Rotate: {rotateBack}°</label>
                        <input
                          type="range"
                          min="-180"
                          max="180"
                          step="1"
                          value={rotateBack}
                          onChange={(e) => setBackRotate(Number(e.target.value))}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </>
                  )}

                  {(selectedFilesBack?.length > 0 ||
                    uploadedFilesBack?.length > 0) &&
                    showCropImageBack === false ? (
                    <div className="uploadImage">
                      <img
                        src={
                          uploadedFilesBack?.length > 0
                            ? `${REACT_APP_S3_BASE_URL}/${uploadedFilesBack}`
                            : URL.createObjectURL(selectedFilesBack[0])
                        }
                        alt="front-image"
                      />
                    </div>
                  ) : null}
                </div>
              </>
            )}
            {selectedOption === "physical" && (
              <Typography
                sx={{
                  fontSize: "14px",
                  lineHeight: "22px",
                  fontWeight: "600",
                  color: "#1A407D",
                  textAlign: "center",
                  mt: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 },
                }}
              >
                Please Upload Later with your RM
              </Typography>
            )}
          </Box>
        </Box>
      </Modal>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
}

export default UploadPopupTwoImages;
